import { shape, func } from 'prop-types';
import { createConfigContext } from '@pegasus/config';
import { injectHelperFunctions } from './helpers';
var _a = createConfigContext({
    isEnabled: function () { return false; },
    getUrl: function () { return '/'; },
    getImage: function () { return '/'; },
    getBrandLogoImage: function () { return '/'; },
    getVideo: function () { return '/'; },
    getCountryCode: function () { return 'DE'; },
    getCountryCodeForAppdomainId: function () { return 'DE'; },
    getSwitchUrl: function () { return null; },
    getSwitchUrlAppdomains: function () { return null; },
    getTimeConstants: function () { return 0; },
}), ConfigProvider = _a.ConfigProvider, useConfig = _a.useConfig, withConfig = _a.withConfig, loadConfigFromBootstrap = _a.loadConfigFromBootstrap;
/**
 * @deprecated Migrate to TypeScript.
 */
var configShape = shape({
    isEnabled: func.isRequired,
    getUrl: func.isRequired,
    getImage: func.isRequired,
    getBrandLogoImage: func.isRequired,
    getVideo: func.isRequired,
    getCountryCode: func.isRequired,
    getCountryCodeForAppdomainId: func.isRequired,
    getSwitchUrl: func.isRequired,
    getSwitchUrlAppdomains: func.isRequired,
    getTimeConstants: func.isRequired,
});
var loadConfig = function () {
    var config = loadConfigFromBootstrap();
    return injectHelperFunctions(config);
};
export { ConfigProvider, configShape, loadConfig, useConfig, withConfig };
